import { useEffect, useMemo, useState } from "react";
import type { DashboardData } from "../../types";
import type { PriceObservation } from "../../types/receipt";
import { loadPriceList } from "../../lib/prices";

/** Every tracked price, reloaded whenever the ledger is, and how many belong to each transaction. */
export function usePriceRows(data: DashboardData | null, setError: (message: string) => void) {
  const [priceRows, setPriceRows] = useState<PriceObservation[]>([]);
  useEffect(() => {
    let active = true;
    loadPriceList(true)
      .then((rows) => {
        if (active) setPriceRows(rows);
      })
      .catch(() => {
        if (active && data) setError("Tracked prices could not be loaded. Refresh to try again.");
      });
    return () => {
      active = false;
    };
  // Reloads prices when a new dashboard load arrives, not on every data change.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.fetchedAt]);
  const trackedCounts = useMemo(() => {
    const map = new Map<string, number>();
    for (const price of priceRows) {
      if (price.transactionId)
        map.set(price.transactionId, (map.get(price.transactionId) || 0) + 1);
    }
    return map;
  }, [priceRows]);
  return { priceRows, setPriceRows, trackedCounts };
}
